import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AGENT_FEATURE } from '@asm/features/asm/store/agent.states';
import { agentReducer } from '@asm/features/asm/store/agent.reducer';
import { AgentEffects } from '@asm/features/asm/store/agent.effect';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(AGENT_FEATURE, agentReducer),
    EffectsModule.forFeature([AgentEffects]),
  ],
})
export class AgentStoreModule {}
